import React from 'react';
import moment from 'moment-timezone';
import type { SalesAttribution } from 'model/salesDashboard';

import styles from './SalesAttributionTable.module.scss';
import { Table } from 'components/UI/V3/Table/Table';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';

const formatCurrency = (value: number): string =>
    `$${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

interface SalesAttributionTableProps {
    salesAttribution: SalesAttribution;
}

export const SalesAttributionTable: React.FC<SalesAttributionTableProps> = ({ salesAttribution }) => {
    if (!salesAttribution.series.length) return null;

    const months = salesAttribution.series[0].data.map(d => ({
        key: d.month,
        label: moment(d.month, 'YYYY-MM').format('MMM')
    }));

    return (
        <div className={styles.tableWrapper}>
            <Table
                firstColumnFixed={true}
                wrapperClassName={styles.tableScrollOverride}
            >
                <TableHeader>
                    <TableHeaderCell>Category</TableHeaderCell>
                    {months.map(month => (
                        <TableHeaderCell key={month.key}>{month.label}</TableHeaderCell>
                    ))}
                </TableHeader>
                <TableBody>
                    {salesAttribution.series.map(series => (
                        <TableRow key={series.key}>
                            <TableCell>{series.label}</TableCell>
                            {months.map(month => {
                                const point = series.data.find(d => d.month === month.key);
                                return <TableCell key={month.key}>{formatCurrency(point?.netSales ?? 0)}</TableCell>;
                            })}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};
